import { useFormikContext } from 'formik';

import { Box } from '@hivebrite/design-system/Box';

import FilesUpload from 'hb-react/shared/components/file/FilesUpload';

import { MODE } from '../constants';
import { type FormValues, type ModeValues } from '../types';

export const Uploads = ({
  jobId,
  mode,
  networkId,
}: {
  jobId?: number;
  mode: ModeValues;
  networkId?: number;
}) => {
  const { values } = useFormikContext<FormValues>();

  const isBO = mode === MODE.BO;

  const fileDeleteRoute = isBO
    ? Routes.delete_file_backoffice_network_uploads_path
    : Routes.delete_file_uploads_path;

  const fileUploadRoute = isBO
    ? Routes.attach_file_backoffice_network_uploads_path
    : Routes.attach_file_uploads_path;

  return (
    <Box pb={3}>
      <FilesUpload
        fileDeleteRoute={fileDeleteRoute}
        fileUploadRoute={fileUploadRoute}
        icon="icon-file"
        uploadParams={{
          network_id: networkId,
          uploadable_id: jobId,
          uploadable_type: 'BusinessOpportunities::Request',
        }}
        uploads={values.uploads}
      />
    </Box>
  );
};
